import { UploadItemCard } from '@app/modules/social-export/publish';
import { WebAppCompositionSocialUploadItemDto } from '@mi-front/api-v2';
import { useComposition } from '../../hooks/useComposition';
import { useComposeSocialExportUploadItemCardActions } from './useComposeSocialExportUploadItemCardActions';

interface ComposeSocialExportUploadItemCardProps {
  upload: WebAppCompositionSocialUploadItemDto;
}

/**
 * Composition social upload card: delegates layout to shared social-export card.
 */
export function ComposeSocialExportUploadItemCard({
  upload,
}: ComposeSocialExportUploadItemCardProps) {
  const { composition } = useComposition();
  const { trigger: actionsTrigger, menuAndDialog: actionsMenuAndDialog } =
    useComposeSocialExportUploadItemCardActions({ compositionId: composition.id, upload });

  return (
    <UploadItemCard
      upload={upload}
      actionsTrigger={actionsTrigger}
      actionsMenuAndDialog={actionsMenuAndDialog}
    />
  );
}
